import React from "react";
import Layout from "../components/organisms/Layout";
import ContactoPage from "../components/pages/contacto/ContactoPage";

const contacto = () => {
	return (
		<Layout landingPage={"person"}>
			<ContactoPage />
		</Layout>
	);
};

export default contacto;
